import leftArrow from "@/assets/left.svg";
import rightArrow from "@/assets/right.svg";
import {FC, useRef} from "react";
import useKeyboardAccessibility from "../hooks/useKeyboardAccessibility";

interface IProps {
    handleClick:(direction: string) => void;
    direction: "left" | "right"
    isFirstPage?: boolean

};

const PatientBackSkip:FC<IProps> = (props:IProps  & { ref?: React.Ref<HTMLDivElement> }) => {
    const {handleClick, direction} = props;

    const ref = useRef<HTMLDivElement>(null);

    const handleKeyPress = () => {
      handleClick(direction === "left" ? "back" : "skip");
    };

    useKeyboardAccessibility(ref, handleKeyPress);

    return (<div  ref={ref} role="button"  tabIndex={0}  onClick={()=>handleClick(direction === "left" ? 'back' : 'skip')} className="back-skip-wrap" >
  {direction === "right" ? <span className="back-skip-text">Skip</span> : null }
    <div className="chevron-link-sm">
         <img className={`vector-stroke ${ direction === "left" ? "left" : "right" }`} alt="Navigate to previous question" src={ direction === "left" ? leftArrow : rightArrow} />  
    </div>
    {direction === "left" ? <span className="back-skip-text">{`${props.isFirstPage ? 'Home' : 'Back'}`}</span> : null }
 </div>)
   
};

export default PatientBackSkip;